import { Box } from "@mui/material";
import { ErrorMessage as HookErrorMessage } from "@hookform/error-message";
import { DeepMap, FieldError, FieldValues } from "react-hook-form";
// Say Lib
import Text from "../Text";

interface Props {
  errors: DeepMap<FieldValues, FieldError>;
  name: string;
}

/**
 * Error message display for hook inputs
 */
const ErrorMessage = ({ errors, name }: Props): JSX.Element => {
  return (
    <HookErrorMessage
      errors={errors}
      name={name}
      render={({ messages, message }): JSX.Element[] | JSX.Element => {
        if (messages) {
          return (
            <Box ml={3.5} mt={1}>
              {Object.entries(messages).map(([type, message]) => (
                <Text
                  key={type}
                  data-testid="multi-error"
                  category="error"
                  shade="light"
                  emphasis="high"
                  variant="caption"
                  component="p"
                >
                  {message}
                </Text>
              ))}
            </Box>
          );
        }
        return (
          <Text
            data-testid="single-error"
            category="error"
            shade="light"
            emphasis="high"
            variant="caption"
            sx={{
              ml: 3.5,
              mt: 1,
            }}
          >
            {message}
          </Text>
        );
      }}
    />
  );
};

export default ErrorMessage;
